import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { StaffLogin } from "./Components/StaffLogin";
import "./App.css";
import Layout from "./Components/Layouts/Layout";
import Logout from "./Utils/Logout";
import {
  AddNewEvent,
  AllEvents,
  AssinedBatches,
  Batches,
  Category,
  EventInfo,
  Home,
  Language,
  Lifestyle,
  Livestream,
  LocationPage,
  NotFound,
  Orders,
  Participants,
  PaymentGateway,
  RegisteredUsers,
  Settings,
  Speakers,
  Sponsors,
  StudentView,
  Trainer,
  ViewBatch,
} from "./Pages";
import { Organizers } from "./Pages/Organizers";
import { EventTypes } from "./Pages/EventTypes";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<StaffLogin />} />
        <Route path="/send_otp" element={<StaffLogin />} />
        <Route path="/verify-otp" element={<StaffLogin />} />
        <Route path="/reset_password" element={<StaffLogin />} />
        <Route path="/set_password" element={<StaffLogin />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/speakers" element={<Speakers />} />
          <Route path="/trainer" element={<Trainer />} />
          <Route path="/livestream" element={<Livestream />} />
          <Route path="/allevent" element={<AllEvents />} />
          <Route path="/participants" element={<Participants />} />
          <Route path="/sponsors" element={<Sponsors />} />
          <Route path="/organizers" element={<Organizers />} />
          <Route path="/event-types" element={<EventTypes />} />
          <Route path="/lifestyle" element={<Lifestyle />} />
          <Route path="/location" element={<LocationPage />} />
          <Route path="/language" element={<Language />} />
          <Route path="/registeredusers" element={<RegisteredUsers />} />
          {/* <Route path="/batch" element={<Batches />} /> */}
          <Route path="/batch/assignedbatch" element={<AssinedBatches />} />
          <Route path="/batch/viewbatch" element={<ViewBatch />} />
          <Route path="/student/:batchId" element={<StudentView />} />
          <Route path="/eventinfo/:eventId" element={<EventInfo />} />
          <Route path="/addnewevent" element={<AddNewEvent />} />
          <Route path="/:eventId/editevent" element={<AddNewEvent />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/category" element={<Category />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/settings" element={<Settings />} />
          <Route
            path="/settings/payment-gateway"
            element={<PaymentGateway />}
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
